/* wsapi3-main v1.0 */
/* Deploy Version 2026-10-08 17:57:04 */
/* Deploy Version 2026-09-24 19:11:11 */
/* Deploy Version 2026-07-27 16:11:02 */
if (window.location.href.indexOf("localhost") == -1) {
  const consoleSubstitute = console;
  console = {
    assert() {
      console.active ? consoleSubstitute.assert.apply(null, arguments) : null;
    },
    clear() {
      console.active ? consoleSubstitute.clear() : null;
    },
    count() {
      console.active ? consoleSubstitute.count.apply(null, arguments) : null;
    },
    countReset() {
      console.active ? consoleSubstitute.countReset.apply(null, arguments) : null;
    },
    debug() {
      console.active ? consoleSubstitute.debug.apply(null, arguments) : null;
    },
    dir() {
      console.active ? consoleSubstitute.dir.apply(null, arguments) : null;
    },
    dirxml() {
      console.active ? consoleSubstitute.dirxml.apply(null, arguments) : null;
    },
    error() {
      console.active ? consoleSubstitute.error.apply(null, arguments) : null;
    },
    group() {
      console.active ? consoleSubstitute.group.apply(null, arguments) : null;
    },
    groupCollapsed() {
      console.active
        ? consoleSubstitute.groupCollapsed.apply(null, arguments)
        : null;
    },
    groupEnd() {
      console.active ? consoleSubstitute.groupEnd.apply(null, arguments) : null;
    },
    info() {
      console.active ? consoleSubstitute.info.apply(null, arguments) : null;
    },
    table() {
      console.active ? consoleSubstitute.table.apply(null, arguments) : null;
    },
    time() {
      console.active ? consoleSubstitute.time.apply(null, arguments) : null;
    },
    timeEnd() {
      console.active ? consoleSubstitute.timeEnd.apply(null, arguments) : null;
    },
    timeLog() {
      console.active ? consoleSubstitute.timeLog.apply(null, arguments) : null;
    },
    trace() {
      console.active ? consoleSubstitute.trace.apply(null, arguments) : null;
    },
    warn() {
      console.active ? consoleSubstitute.warn.apply(null, arguments) : null;
    },
    log() {
      console.active ? consoleSubstitute.log.apply(null, arguments) : null;
    },
    enable() {
      console.active = !console.active;
      window.localStorage.setItem("logEnable", console.active);
    },
    active: !!window.localStorage.getItem("logEnable") || false,
  };
}

// Declaring Module Manager
class wsMainjs {
  constructor() {
    this.moduleArr = [];
    this.modules = {};
    this.options = {};
    this.globalData = {};
    this.tools = {};
    this.data = {};
    this['prod-slides'] = [];
    this.variationUpdate;
  }
  setModule(obj = {}, moduleName, after) {
    if (!obj) return;
    if (typeof obj != "function" && typeof obj != "object") return;

    if (!moduleName) {
      if (typeof obj == "function") {
        moduleName = obj.name;
      }
      if (typeof obj == "object") {
        obj.function.name;
      }
    }

    let moduleToreturn = {
      funcName: moduleName,
      function: typeof obj == "function" ? obj : obj.function
    }

    if (after && typeof after == "string") {
      moduleToreturn['onlyAfter'] = after;
    }

    this.moduleArr.push(moduleToreturn);
  }
  createModule(obj) {
    obj["setOption"] = (opt, value) => {
      wsMain.options[obj.name][opt] = value;
    };

    if (obj.options) {
      wsMain.setOptions(obj.options, obj.name);
    }

    this.modules[obj.name] = obj;
    delete this.modules[obj.name].options;

    if (obj.function)
      this.setModule(wsMain.modules[obj.name][obj.function], obj.name, obj.onlyAfter || false);
  }
  setOptions(obj, name) {
    if (this.options[name]) {
      this.options[name] = { ...obj, ...this.options[name] };
    } else {
      this.options[name] = obj;
    }
  }
  setGlobalData(name, obj) {
    this.globalData[name] = obj;

    switch (name) {
      case 'infoBanners':
        name = 'Banners'
        break;
      case 'infoManufactureres':
        name = 'Fabricantes'
        break;
      case 'infoCart':
        name = 'carrinho'
        break;
      case 'infoCategory':
        name = 'CategoriasLista'
        break;
      case 'listGroupProds':
        name = 'ProdutosGrupos'
        break;
      case 'listHighlightProds':
        name = 'ProdutosDestaque'
        break;
      case 'listRelatedProds':
        name = 'ListaProdutosRelacionados'
        break;
      case 'infoProduto':
        name = 'ProdutoDadosRetorno'
        break;
      case 'listCategoryProds':
        name = 'ProdutosListagem';
        break;
      case 'listHomeProds':
        name = 'ProdutosHome';
        break;
      case 'infoLoja':
        name = 'InfosLojas';
        break;
      default:
        break;
    }

    objetos[name] = JSON.stringify(obj);
  }
  async exec(funcs, toLog = false) {
    let arr = funcs || this.moduleArr;
    if (toLog) console.group(toLog)
    let promises = arr.map(async module => {
      try {
        if (module.onlyAfter) {
          wsMain.execAfter(module.onlyAfter, module);
        } else {
          let success;
          try {
            success = await module.function();
          } catch (err) {
            throw err;
          }

          if (success && !module.onlyAfter) {
            module.isOk = true;
            console.log(`The module ${module.funcName} was executed correctly!`, module);
          } else {
            console.log(module);
            throw 'Erro desconhecido';
          }
        }
      } catch (err) {
        console.log(`The Module ${module.funcName} deu errado :(`);
        console.error(err);
      }

      wsMain.addons.lazyLoad();
      wsMain.tools.lineClamp();
    });

    await Promise.all(promises);

    if (toLog) console.groupEnd(toLog)
  }
  async execAfter(modName, module) {
    // Timeout de segurança pros dois ramos abaixo (onlyAfter:"all" e onlyAfter:"<nome>"):
    // ambos ficavam num setInterval esperando pra sempre, sem nenhuma saída, se a condição
    // de espera nunca fosse satisfeita — basta UM módulo (o "all" inteiro, ou o módulo
    // específico nomeado) nunca chegar a isOk=true (exceção não tratada, resposta de API
    // inesperada — falha real, não "só lento") pra travar permanentemente quem depende dele:
    // carrinho/personal-shopper (onlyAfter:"all") ou categorias/condição/página de produto
    // (onlyAfter:"info-lojas"), mesmo sem relação nenhuma entre o módulo que falhou e o que
    // ficou esperando. Depois desse tempo sem a condição bater, desiste de esperar e roda
    // mesmo assim — "bom o bastante" com o que já chegou é melhor que travado pra sempre.
    const ONLY_AFTER_TIMEOUT_MS = 8000;
    const startedAt = Date.now();

    if (modName == 'all') {

      let modVerify = setInterval(() => {
        let allOk = true;
        wsMain.moduleArr.forEach(mods => {
          // Bug real: era "allOk = mods.isOk" (sobrescrevia a cada volta do forEach —
          // só o ÚLTIMO módulo do array decidia o resultado, não "todos"). Módulos
          // registrados via setTimeout (ex.: wsapi3-apps' checkout-suggestion) ou
          // neutralizados de propósito (suggestion-slider vira noop, nunca marca
          // isOk) acabando no fim do array travavam qualquer módulo onlyAfter:"all"
          // pra sempre — sintoma real: carrinho/personal-shopper nunca ficam
          // clicáveis. mods.onlyAfter continua pendente até seu próprio
          // execAfter zerar a flag — não conta como "travando" outro onlyAfter:"all".
          if (mods.funcName != module.funcName && mods.funcName != "placeholders" && !mods.onlyAfter) {
            allOk = allOk && !!mods.isOk;
          }
        });

        const timedOut = Date.now() - startedAt >= ONLY_AFTER_TIMEOUT_MS;
        if (!allOk && !timedOut) return;
        if (!allOk) console.warn(`[wsMain] onlyAfter:"all" do módulo "${module.funcName}" expirou após ${ONLY_AFTER_TIMEOUT_MS}ms esperando os demais — rodando mesmo assim.`);

        clearInterval(modVerify);
        try { delete module.onlyAfter } catch (_) { }
        try { wsMain.exec([module]) } catch (_) { }
      }, 100);

    } else {

      let modVerify = setInterval(() => {
        const target = wsMain.moduleArr.find(mods => mods.funcName == modName);
        const ready = target?.isOk == true;
        const timedOut = Date.now() - startedAt >= ONLY_AFTER_TIMEOUT_MS;

        if (!ready && !timedOut) return;
        if (!ready) console.warn(`[wsMain] onlyAfter:"${modName}" do módulo "${module.funcName}" expirou após ${ONLY_AFTER_TIMEOUT_MS}ms esperando "${modName}" — rodando mesmo assim.`);

        clearInterval(modVerify);
        try { delete module.onlyAfter } catch (_) { }
        try { wsMain.exec([module]) } catch (_) { }
      }, 100);
    }
  }
}

// Declaring Global Object
let objetos = {};

// Instantiating the Module Manager
ApiWS.ApiStart();
let wsMain = new wsMainjs();

// Dealing functions
wsMain.data = {
  getYouTubeVideoId(string) {
    try {
      let url = new URL(string)
      let videoId = url.searchParams.get('v')
      if (!videoId) videoId = url.pathname.split('/')[url.pathname.split('/').length - 1]

      return videoId;
    } catch (err) {
      return ''
    }
  },
  treatPrice(val) {
    try{
      // toLocaleString com options cria um Intl.NumberFormat novo a cada chamada (caro:
      // ~1s de CPU na home com vários carrosséis). Reaproveita um só pra números; o resto
      // (string, null...) segue o caminho original pra manter o mesmo resultado.
      if (typeof val === 'number') {
        if (!wsMain.data._brlFormat) wsMain.data._brlFormat = new Intl.NumberFormat("pt-br", { style: "currency", currency: "BRL", minimumFractionDigits: 2 });
        return wsMain.data._brlFormat.format(val);
      }
      return val.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      });
    } catch (err) {
      return "R$ 0,00";
    }
  },
  cellphoneFilter(e) {
    if (parseInt(e.key).toString() == 'NaN' || e.target.value.length >= 15) e.preventDefault();
  },
  quantityFilter(e, maxlength = 3) {
    if (parseInt(e.key).toString() == 'NaN') e.preventDefault();

    if (e.target.value.length >= maxlength) {
      let selected = window.getSelection();
      console.log(selected.anchorNode, e.target, e.currentTarget);
      if (selected.type != 'Range' || selected.toString().trim() == '' || (e.target != selected.anchorNode && !selected.anchorNode.contains(e.target))) e.preventDefault();
    }

    if (parseInt(e.target.value + '' + e.key) < parseInt(e.target.getAttribute('min'))) {
      e.target.value = e.target.getAttribute('min')
      e.preventDefault();
    }

    if (parseInt(e.target.value + '' + e.key) > parseInt(e.target.getAttribute('max'))) {
      e.target.value = e.target.getAttribute('max')
      e.preventDefault();
    }

    return
  },
  cellphoneMask(e) {
    let v = e.target.value.replace(/\D/g, "");
    if (v.length > 7) v = v.replace(/^(\d{1,2})(\d{1,5})(\d{0,})/, "($1) $2-$3");
    if (v.length <= 7 && v.length >= 3) v = v.replace(/^(\d{1,2})(\d{1,5})/, '($1) $2');
    if (v.length <= 2) v = v.replace(/^(\d{1,2})/, '($1)');
    console.log(v.length);
    if (v.length < 15) {
      e.target.value = v;
    } else {
      e.target.value;
    }
  },
  treatIcon: tag => {
    if (wsMain.globalData.icons) {
      tag.innerHTML = wsMain.globalData.icons[tag.getAttribute('data-wsjs-icon').toLowerCase()] || tag.getAttribute('data-wsjs-icon')
      tag.setAttribute('data-wsjs-icon', '');
    }
  },
  compostFeeValue(Juros, NumParcela, ParcelaJurosInicia, Valor) {
    try {
      if (Juros > 0 && NumParcela >= ParcelaJurosInicia && NumParcela > 1) {
        return (Valor * (Juros / 100)) / (1 - (1 / (Math.pow((1 + (Juros / 100)), ((NumParcela))))));
      }
      else {
        return (Valor / NumParcela);
      }
    } catch (e) { }

    return ValorParcela;
  }
}

// Tool Functions
wsMain.tools = {
  // Overlay de carregamento padrão do site (spinner central, fundo com leve
  // blur) — usado em várias páginas (produto, área do cliente, checkout,
  // carrinho, ...) pra não cada uma reinventar o próprio spinner com
  // tamanho/cor diferente. Uma atualização aqui já reflete em todo lugar.
  // showLoading()/hideLoading() são contados (refs): chamadas concorrentes
  // (ex.: dois módulos carregando ao mesmo tempo) reusam o mesmo overlay em
  // vez de empilhar um por cima do outro, e só remove de fato quando o
  // último hideLoading() correspondente é chamado.
  showLoading() {
    let loadingDiv = document.querySelector('.main-loading-overlay');
    if (loadingDiv) {
      loadingDiv.dataset.refs = String(Number(loadingDiv.dataset.refs || '1') + 1);
      loadingDiv.style.opacity = '1';
      return;
    }

    loadingDiv = document.createElement('div');
    loadingDiv.classList.add('main-loading-overlay');
    loadingDiv.dataset.refs = '1';

    let spinner = document.createElement('div');
    spinner.classList.add('main-loading-spinner');
    loadingDiv.appendChild(spinner);

    document.body.appendChild(loadingDiv);

    setTimeout(() => {
      loadingDiv.style.opacity = '1';
    }, 0);
  },
  hideLoading() {
    let loadingDiv = document.querySelector('.main-loading-overlay');
    if (!loadingDiv) return;

    let refs = Number(loadingDiv.dataset.refs || '1') - 1;
    if (refs > 0) {
      loadingDiv.dataset.refs = String(refs);
      return;
    }

    loadingDiv.style.opacity = '0';
    setTimeout(() => {
      if (loadingDiv.parentNode) loadingDiv.parentNode.removeChild(loadingDiv);
    }, 300); // O tempo deve coincidir com a duração da transição no CSS
  },
  // Mesmo spinner de showLoading(), só que como snippet HTML pra colar DENTRO
  // de um elemento já existente na página (uma lista carregando, um card,
  // etc.) em vez de cobrir a tela inteira. Cada página continua responsável
  // por decidir onde/quando mostrar esse trecho (ex.: innerHTML de um
  // "Carregando..." — ver wsapi3-customer-area-page.js) — só o desenho do
  // spinner em si vem daqui, pra não cada lugar inventar um tamanho/cor.
  inlineSpinnerHtml() {
    return '<div class="main-loading-spinner main-loading-spinner--inline"></div>';
  },
  breadcrumb(arr) {
    let div = wsMain.tools.createElm('div');
    arr.forEach((crumb, i) => {
      let crumbSpam = wsMain.tools.createElm('span');

      let hiperLink = wsMain.tools.createElm({
        type: 'a',
        innerHTML: crumb.nome,
        attrs: {
          href: crumb.url
        }
      });

      div.append(hiperLink);
      if (i != arr.length - 1) div.append(crumbSpam);
    });
    return div;
  },
  // Cloudflare Image Resizing (/cdn-cgi/image/...) configurado pelo objeto global `imageResize`
  // do head da loja (mesmo esquema do sidebarCart). ESPELHO de src/layout/image-resize.ts —
  // precisa gerar exatamente as mesmas URLs do SSR. attrs(url, area) → {src, srcset, sizes} ou
  // null (sem config / área não configurada / host fora da lista → mantém a URL original).
  imageResize: {
    _cfg: undefined,
    config() {
      if (this._cfg !== undefined) return this._cfg;
      let raw = null;
      try { raw = typeof imageResize != 'undefined' ? imageResize : window.imageResize; } catch (_) { }
      this._cfg = null;
      if (!raw || typeof raw != 'object' || raw.ativo === false) return null;
      if (!raw.areas || typeof raw.areas != 'object' || !Object.keys(raw.areas).length) return null;
      const num = (v, fb) => { const n = Number(v); return isFinite(n) && n > 0 ? n : fb; };
      const bp = raw.breakpoints || {};
      this._cfg = {
        qualidade: Math.min(100, num(raw.qualidade, 85)),
        fit: typeof raw.fit == 'string' && raw.fit ? raw.fit : 'scale-down',
        formato: raw.formato === false ? '' : typeof raw.formato == 'string' ? raw.formato : 'auto',
        larguraMaxima: num(raw.larguraMaxima, 2560),
        breakpoints: { tablet: num(bp.tablet, 768), desktop: num(bp.desktop, 1200) },
        hosts: Array.isArray(raw.hosts) && raw.hosts.length ? raw.hosts.map(h => String(h).toLowerCase()) : ['imageswscdn.wslojas.com.br'],
        areas: raw.areas
      };
      return this._cfg;
    },
    _area(cfg, name) {
      const pick = (key) => {
        const v = cfg.areas[key];
        if (v === undefined || v === null || v === false) return null;
        return typeof v == 'object' ? v : { mobile: v, tablet: v, desktop: v };
      };
      const area = pick(name) || (name.indexOf('-') > -1 ? pick(name.split('-')[0]) : null);
      return area && area.ativo !== false ? area : null;
    },
    _width(v) {
      if (v === undefined || v === null || v === '') return null;
      if (typeof v == 'number') return v > 0 ? { px: Math.round(v) } : null;
      const s = String(v).trim().toLowerCase();
      const vw = s.match(/^(\d+(?:\.\d+)?)vw$/);
      if (vw) return { vw: Number(vw[1]) };
      const px = parseFloat(s);
      return px > 0 ? { px: Math.round(px) } : null;
    },
    attrs(url, areaName) {
      const cfg = this.config();
      if (!cfg || !url || !areaName) return null;
      const area = this._area(cfg, areaName);
      if (!area) return null;

      const m = /^(https?:)?\/\/([^/?#]+)(\/[^?#]*)(\?[^#]*)?/i.exec(String(url).trim());
      if (!m) return null;
      const path = m[3];
      if (cfg.hosts.indexOf(m[2].toLowerCase()) == -1 || path.indexOf('/cdn-cgi/') == 0 || /\.(svg|mp4|webm)$/i.test(path)) return null;

      const raw = { mobile: this._width(area.mobile), tablet: this._width(area.tablet), desktop: this._width(area.desktop) };
      const mobile = raw.mobile || raw.tablet || raw.desktop;
      const tablet = raw.tablet || raw.desktop || raw.mobile;
      const desktop = raw.desktop || raw.tablet || raw.mobile;
      if (!mobile || !tablet || !desktop) return null;

      const bp = cfg.breakpoints, max = cfg.larguraMaxima;
      const widths = [];
      const add = (w, samples) => {
        const base = w.px ? [w.px] : samples.map(s => s * w.vw / 100);
        base.forEach(b => [1, 2].forEach(dpr => {
          const px = Math.min(max, Math.round(b * dpr));
          if (px > 0 && widths.indexOf(px) == -1) widths.push(px);
        }));
      };
      add(mobile, [414, bp.tablet - 1]);
      add(tablet, [bp.desktop - 1]);
      add(desktop, [1440, 1920]);
      widths.sort((a, b) => a - b);

      const quality = Math.min(100, Number(area.qualidade) > 0 ? Number(area.qualidade) : cfg.qualidade);
      const fit = area.fit || cfg.fit;
      const format = area.formato === false ? '' : typeof area.formato == 'string' ? area.formato : cfg.formato;
      const origin = (m[1] || 'https:') + '//' + m[2];
      const tail = path + (m[4] || '');
      const cfUrl = (w) => `${origin}/cdn-cgi/image/width=${w},fit=${fit},quality=${quality}${format ? ',format=' + format : ''}${tail}`;

      const cssSize = (w) => w.px ? w.px + 'px' : w.vw + 'vw';
      const tiers = [[`(min-width: ${bp.desktop}px)`, cssSize(desktop)], [`(min-width: ${bp.tablet}px)`, cssSize(tablet)], [null, cssSize(mobile)]];
      const sizes = tiers
        .filter((t, i) => i == tiers.length - 1 || t[1] !== tiers[i + 1][1])
        .map(t => t[0] ? t[0] + ' ' + t[1] : t[1])
        .join(', ');

      const desktopPx = desktop.px || Math.round(1440 * desktop.vw / 100);
      return {
        src: cfUrl(Math.min(max, desktopPx)),
        srcset: widths.map(w => cfUrl(w) + ' ' + w + 'w').join(', '),
        sizes: sizes
      };
    }
  },
  // width/height das <img> por área + dispositivo, do objeto global `imageDimensions` do head
  // (ex.: { product_list: { mobile: '300x300', desktop: '600x600', home: { desktop: '600x750' } }, banner: { full: '1920x500' } }).
  // Chaves em inglês; o imgArea/data-ws-img segue em pt (compartilhado com o imageResize) e é
  // traduzido em _key (produtos → product_list, fabricantes → manufacturers, topo/tarja/rodape → top/stripe/footer).
  // ESPELHO de src/layout/image-dimensions.ts — resolve igual ao SSR. get(area) → {w, h} ou null.
  imageDimensions: {
    _cfg: undefined,
    config() {
      if (this._cfg !== undefined) return this._cfg;
      let raw = null;
      try { raw = typeof imageDimensions != 'undefined' ? imageDimensions : window.imageDimensions; } catch (_) { }
      this._cfg = raw && typeof raw == 'object' && !Array.isArray(raw) && raw.enabled !== false ? raw : null;
      return this._cfg;
    },
    _parse(v) {
      let w, h;
      if (typeof v == 'string') {
        const m = /^\s*(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)\s*$/i.exec(v);
        if (!m) return null;
        w = m[1]; h = m[2];
      } else if (Array.isArray(v)) {
        w = v[0]; h = v[1];
      } else if (v && typeof v == 'object') {
        w = v.w != null ? v.w : v.width;
        h = v.h != null ? v.h : v.height;
      } else return null;
      w = Math.round(Number(w)); h = Math.round(Number(h));
      return w > 0 && h > 0 ? { w: w, h: h } : null;
    },
    _isValue(v) {
      if (typeof v == 'string' || Array.isArray(v)) return true;
      return !!v && typeof v == 'object' && Object.keys(v).some(k => ['mobile', 'desktop', 'w', 'h', 'width', 'height'].indexOf(k) > -1);
    },
    _device(v, key) {
      if (!this._isValue(v)) return null;
      return this._parse(v) || this._parse(v[key]);
    },
    _key(area) {
      const dash = area.indexOf('-');
      const prefix = dash > 0 ? area.slice(0, dash) : area;
      let suffix = dash > 0 ? area.slice(dash + 1) : '';
      if (prefix == 'banner' && suffix) suffix = ({ topo: 'top', tarja: 'stripe', rodape: 'footer' })[suffix] || suffix;
      const key = ({ produtos: 'product_list', fabricantes: 'manufacturers' })[prefix] || prefix;
      return suffix ? key + '-' + suffix : key;
    },
    get(area) {
      const cfg = this.config();
      if (!cfg || !area) return null;
      area = this._key(area);
      let device = 'D';
      try { device = document.querySelector('#HD_VRS_MOBILE').value.toLowerCase() == 'false' ? 'D' : 'M'; } catch (_) { } // mesma regra do wsapi3-banners
      const dash = area.indexOf('-');
      const candidates = [cfg[area]];
      if (dash > 0) {
        const group = cfg[area.slice(0, dash)];
        // Sub-área e padrão podem conviver no mesmo objeto: { mobile, desktop, home: {...} }.
        if (group && typeof group == 'object' && !Array.isArray(group)) candidates.push(group[area.slice(dash + 1)]);
        candidates.push(group);
      }
      // 1º o próprio dispositivo em todos os níveis, só então o outro (igual ao SSR).
      const order = device == 'M' ? ['mobile', 'desktop'] : ['desktop', 'mobile'];
      for (const key of order) {
        for (const c of candidates) {
          if (c === undefined || c === null || c === false) continue;
          const dims = this._device(c, key);
          if (dims) return dims;
        }
      }
      return null;
    }
  },
  createElm(obj) {
    if (typeof obj == "string") return document.createElement(obj);

    // imgArea + imageDimensions do head: troca width/height pelos da área/dispositivo.
    if (obj.imgArea && obj.type == 'img') {
      try {
        const dims = wsMain.tools.imageDimensions.get(obj.imgArea);
        if (dims) obj.attrs = Object.assign({}, obj.attrs, { width: dims.w, height: dims.h });
      } catch (_) { }
    }

    // imgArea: área do imageResize (ex.: 'produtos-home', 'banner-full', 'fabricantes'). Troca
    // src/otherSrc pela variante do Cloudflare e acrescenta srcset/sizes (srcset segue o mesmo
    // lazyload do src, via data-wsjs-srcset).
    let resized = null, resizedOther = null;
    if (obj.imgArea && obj.attrs && obj.type == 'img') {
      try {
        obj.attrs = Object.assign({}, obj.attrs);
        if (obj.attrs.src) {
          resized = wsMain.tools.imageResize.attrs(obj.attrs.src, obj.imgArea);
          if (resized) obj.attrs.src = resized.src;
        }
        if (obj.attrs.otherSrc) {
          resizedOther = wsMain.tools.imageResize.attrs(obj.attrs.otherSrc, obj.imgArea);
          if (resizedOther) {
            obj.attrs.otherSrc = resizedOther.src;
            obj.attrs.otherSrcset = resizedOther.srcset;
          }
        }
        const sizes = (resized || resizedOther || {}).sizes;
        if (sizes) obj.attrs.sizes = sizes;
        obj.attrs['data-ws-img'] = obj.imgArea;
      } catch (_) { resized = resizedOther = null; }
    }

    let elm = document.createElement(obj.type);
    if (obj.attrs) {
      Object.keys(obj.attrs).forEach((key) => {
        if (key != "src") {
          if (obj.attrs[key]) {
            elm.setAttribute(key, obj.attrs[key]);
          };
        }
      });
    }

    if (obj.innerHTML) elm.innerHTML = obj.innerHTML;

    if (obj.attrs?.src) {
      if (obj.lazyLoad != false && typeof nPanel == 'undefined') {
        elm.setAttribute("data-wsjs-src", obj.attrs.src);
        if (resized) elm.setAttribute("data-wsjs-srcset", resized.srcset);
        elm.setAttribute("data-wsjs-lazyload", "scroll");
        elm.classList.add("lazyload");
      } else {
        if (resized) elm.setAttribute("srcset", resized.srcset);
        elm.setAttribute("src", obj.attrs.src);
      }
    }



    return elm;
  },
  createSlide(elmToSlide, obj = {}, plugins = []) {
    if (!elmToSlide) return;
    let usedOptions = {
      loop: true,
      slides: {
        perView: 1,
      },
      lazyLoad: false,
      autoplay: false,
      arrows: true,
      dots: false
    };

    function updateJson(objToOverlay, baseObj) {
      Object.keys(objToOverlay).forEach(k => {
        if (typeof objToOverlay[k] == 'object') {
          if (!baseObj[k] || typeof baseObj[k] != 'object') baseObj[k] = {}
          updateJson(objToOverlay[k], baseObj[k])
        } else {
          baseObj[k] = objToOverlay[k]
        }
      })
    }

    updateJson(obj, usedOptions);

    let childrenLength = parseInt(Array.from(elmToSlide.children).length);

    if (usedOptions.slides.min && childrenLength < usedOptions.slides.min) return [true, false];

    let arrChildren = Array.from(elmToSlide.children).map(elm => {
      let newDiv = wsMain.tools.createElm({
        type: "div",
        attrs: {
          class: "keen-slider__slide",
        }
      });

      newDiv.append(elm);
      return newDiv;
    });

    elmToSlide.innerHTML = "";

    let wrapper = wsMain.tools.createElm({
      type: "div",
      attrs: {
        class: "keen-slider",
      }
    });

    arrChildren.forEach((elm) => wrapper.append(elm));

    let animationDelay = usedOptions.autoplay;

    if (animationDelay && animationDelay > 0 && !isNaN(animationDelay) && childrenLength > usedOptions.slides.perView) {
      function AutoPlayPlugin() {
        return slider => {
          slider.on('created', () => {
            setTimeout(() => slider.next(), animationDelay);
          });

          let slideOff = true;
          slider.on('animationEnded', () => {
            if (slideOff) {

              setTimeout(() => {
                slider.next()
                slideOff = true;
              }, animationDelay);

              slideOff = false;
            }
          });
        }
      }

      plugins.push(AutoPlayPlugin());
    }

    if (usedOptions.lazyLoad) {
      function LazyLoadSlidePlugin() {
        return slider => {
          let lazyImages = [];

          // On Slide Create
          slider.on('created', () => {
            // Encontrar todas as imagens com data-wsjs-lazyload="scroll"
            lazyImages = slider.container.querySelectorAll('img[data-wsjs-lazyload="scroll"]');

            lazyImages.forEach((img, i) => {
              // Alterar para data-wsjs-lazyload="slide"
              if (i > (Math.ceil(slider.options.slides.perView)-1)) {
                img.setAttribute('data-wsjs-lazyload', 'slide');
              }
            });
          });

          // On Slide Change
          slider.on('slideChanged', () => {
            let currentSlide = slider.track.details.rel;

            slider.slides.forEach((slide, i) => {
              if (i >= Math.abs(currentSlide) && i <= Math.abs(currentSlide) + (Math.ceil(slider.options.slides.perView)-1)) {

                slide.querySelectorAll('img[data-wsjs-lazyload="slide"]').forEach(img => {
                  if (!img.src) {
                    let src = img.getAttribute('data-wsjs-src');
                    img.src = src;
  
                    img.style.minHeight = '';
                    img.removeAttribute("data-wsjs-lazyload");
                    img.removeAttribute("data-wsjs-src");
                    img.classList.remove("lazyload");
  
                  }
                })
              }
            });
          });
        };
      }

      plugins.push(LazyLoadSlidePlugin());
    }

    // Adding Wrapper Fulled With Elements
    elmToSlide.append(wrapper);
    elmToSlide.classList.add("slide-container");

    let slider = new KeenSlider(elmToSlide.querySelector(":scope > .keen-slider"), usedOptions, plugins);

    function getDots(n, m) {
      let dots = [];
      let numViews = Math.floor(n / m);  // Number of views (including incomplete views)

      for (let i = 0; i < numViews; i++) {
        dots.push(i * m);  // Add the starting index of each view
      }

      if (n % m !== 0 && numViews > 0) {
        dots.push(numViews * m);
      }

      return dots;
    }

    function getClosestIndex(arr, target) {
      let closest = Infinity;
      let index = -1;

      for (let i = 0; i < arr.length; i++) {
        let difference = Math.abs(target - arr[i]);

        if (difference < closest) {
          closest = difference;
          index = i;
        }
      }

      return index;
    }

    if (childrenLength > usedOptions.slides.perView) {
      if (usedOptions.arrows || usedOptions.prevArrow) {
        let prevArrow = wsMain.tools.createElm({
          type: "span",
          innerHTML: typeof usedOptions.prevArrow != 'string' ? '<span data-wsjs-icon="Arrow"></span>' : usedOptions.prevArrow,
          attrs: {
            class: "arrow arrow--prev icon-ws",
          },
        });

        prevArrow.addEventListener("click", () => {
          if (usedOptions.arrowsType != 'group') slider.prev();
          else {
            let arrowsSlides = getDots(slider.track.details.slides.length, usedOptions.slides.perView);

            if (arrowsSlides.length <= 1) slider.moveToIdx(0);
            else {
              let closestArrow = getClosestIndex(arrowsSlides, slider.track.details.rel);
              if (typeof arrowsSlides[closestArrow - 1] != 'undefined') slider.moveToIdx(arrowsSlides[closestArrow - 1]);
              else slider.moveToIdx(arrowsSlides[arrowsSlides.length - 1]);
            }
          }
        });
        elmToSlide.prepend(prevArrow);
      }

      if (usedOptions.arrows || usedOptions.nextArrow) {
        let nextArrow = wsMain.tools.createElm({
          type: "span",
          innerHTML: typeof usedOptions.nextArrow != 'string' ? '<span data-wsjs-icon="Arrow"></span>' : usedOptions.nextArrow,
          attrs: {
            class: "arrow arrow--next icon-ws",
          },
        });

        nextArrow.addEventListener("click", () => {
          if (usedOptions.arrowsType != 'group') slider.next();
          else {
            let arrowsSlides = getDots(slider.track.details.slides.length, usedOptions.slides.perView);

            if (arrowsSlides.length <= 1) slider.moveToIdx(0);
            else {
              let closestArrow = getClosestIndex(arrowsSlides, slider.track.details.rel);
              if (typeof arrowsSlides[closestArrow + 1] != 'undefined') slider.moveToIdx(arrowsSlides[closestArrow + 1]);
              else slider.moveToIdx(arrowsSlides[0]);
            }
          }
        });
        elmToSlide.append(nextArrow);
      }

      if (usedOptions.dots) {
        let dots = wsMain.tools.createElm({
          type: "div",
          attrs: {
            class: "dots",
          },
        });

        let dotsSlide = [];

        if (usedOptions.dotsType == 'group') {
          dotsSlide = getDots(slider.track.details.slides.length, usedOptions.slides.perView);
        } else {
          dotsSlide = slider.track.details.slides.map((_e, idx) => idx);
        }

        dotsSlide.forEach(idx => {
          let dot = wsMain.tools.createElm({
            type: "span",
            innerHTML:
              typeof usedOptions.dots != "string" ? "<span class='slide-dot'></span>" : usedOptions.dots,
            attrs: {
              class: `slide-dots ${idx == 0 ? 'active' : ''}`,
            },
          });

          dot.addEventListener("click", () => slider.moveToIdx(idx))

          slider.on('slideChanged', (s) => {
            let dotIdx = dotsSlide.indexOf(s.track.details.rel);
            if (dotIdx == -1) return;

            let dot = s.container.parentNode.querySelectorAll('.slide-dots')[dotIdx];

            if (dot) {
              s.container.parentNode.querySelector('.slide-dots.active').classList.remove('active');
              dot.classList.add('active');
            }
          })

          dots.appendChild(dot);
        })

        elmToSlide.appendChild(dots);

      }

    } else {
      if (usedOptions.alignCenter) usedOptions.slides.perView = childrenLength;

      // Removing Drag And Arrows
      if (usedOptions.needOffset) elmToSlide.classList.add('need-offset');
      else elmToSlide.setAttribute('style', 'grid-template-columns: auto;');

      slider.update({ ...usedOptions, drag: false });
    }

    return [true, slider];
  },
  getWsData(elm, typeData) {
    if (!elm) return false;

    let opt = {};
    let optionsText = elm.getAttribute("data-wsjs-" + typeData);

    if (typeData == 'slide' && optionsText === null) return false;

    if (optionsText === null || optionsText.trim() == '') return opt;

    let optionsArr = optionsText.split(';');

    if (optionsArr[optionsArr.length - 1].trim() == '') optionsArr = optionsArr.slice(0, -1);

    optionsArr.forEach(optKey => {
      let keyName = optKey.split(':')[0].trim(),
        keyValue = optKey.split(':')[1].trim();

      if (keyValue == 'false') keyValue = false;
      if (keyValue == 'true') keyValue = true;

      let optToChange = opt;
      keyName.split('.').forEach((k, i) => {
        optToChange = optToChange[k] = i == keyName.split('.').length - 1 ? keyValue : optToChange[k] || {};
      });
    });
    return opt;
  },
  replaceSpanTag(elm, tag, container = false, clone = false) {
    try {
      let elmToQuery = container ? container : document;
      let divPlaceHolder = typeof tag == 'string' ? elmToQuery.querySelector(`[data-wsjs-${tag}]`) : tag;
      if (!divPlaceHolder || (!Array.isArray(divPlaceHolder) && divPlaceHolder.length == 0)) return;

      let elmToPut = clone ? elm.cloneNode(true) : elm;

      divPlaceHolder.getAttributeNames().forEach((attr) => {
        if (
          attr != "data-wsjs-module" &&
          attr != "data-wsjs-options" &&
          attr != 'data-wsjs-infos' &&
          attr != 'data-wsjs-banner' &&
          attr != 'data-wsjs-listing' &&
          attr != 'data-wsjs-prod-list' &&
          attr != 'data-wsholder' &&
          attr != 'data-wsjs-cart'
        ) {
          if (attr == 'class') divPlaceHolder.classList.forEach(c => elmToPut.classList.add(c));
          else elmToPut.setAttribute(attr, divPlaceHolder.getAttribute(attr));
        }
      });

      divPlaceHolder.parentNode.replaceChild(elmToPut, divPlaceHolder);
      wsMain.addons.lazyLoad();
      wsMain.addons.dataLoad(elmToPut)

      setTimeout(() => {

        try {
          additionalPanel.loadAdvancedElements();
        } catch (e) { }

        try {
          let event = new Event('resize')
          window.dispatchEvent(event);
        } catch (e) { }

        elmToPut.style.minHeight = '';
      }, 20);
    } catch (err) {
      console.log(err);
    }
  },
  lazyLoad(elm) {
    elm.style.minHeight = '';
    elm.removeAttribute("data-wsjs-lazyload");
    if (elm.hasAttribute("data-wsjs-srcset")) {
      elm.setAttribute("srcset", elm.getAttribute("data-wsjs-srcset"));
      elm.removeAttribute("data-wsjs-srcset");
    }
    elm.setAttribute("src", elm.getAttribute("data-wsjs-src"));
    elm.removeAttribute("data-wsjs-src");
    elm.classList.remove("lazyload");
  },
  copyLink(elm) {
    navigator.clipboard.writeText(window.location.href.toString());
    elm.setAttribute("style", "transform: translateY(-110%)");
    setTimeout(() => {
      elm.removeAttribute("style");
    }, 500);
  },
  async replaceSubFunctions(obj, subFunctions, spanTag) {
    let arrFunctions = Object.keys(subFunctions).filter((k) => document.querySelector(`*[data-wsjs-${spanTag}=${k}]`));

    arrFunctions.forEach((key) => {
      try {
        let subFunction = subFunctions[key],
          spans = document.querySelectorAll(`*[data-wsjs-${spanTag}=${key}]`);

        spans.forEach(span => {
          let spanOptions = wsMain.tools.getWsData(span, 'options'),
            // SSR preenche o span e guarda o conteúdo original do tema em data-wsjs-ssr-text
            spanText = span.hasAttribute('data-wsjs-ssr-text') ? span.getAttribute('data-wsjs-ssr-text') : span.innerHTML;
          let elm;

          try {
            elm = subFunction(obj, spanOptions, spanText);
            if (span.hasAttribute('data-wsjs-force')) span.setAttribute('data-wsjs-force', 'load')
          } catch (_) {
            if (span.hasAttribute('data-wsjs-force')) span.setAttribute('data-wsjs-force', 'none');
            else span.remove();
          }

          if (elm) {
            wsMain.tools.replaceSpanTag(elm, span, false, true);
          } else {
            if (span.hasAttribute('data-wsjs-force')) span.setAttribute('data-wsjs-force', 'none');
            else span.remove();
          }

        });
      } catch (err) {
        console.log(err);
      }
    });
    return;
  },
  removeAll(tag, elm) {
    try {
      document.querySelectorAll(`[data-wsjs-${tag}='${elm}']`).forEach(item => item.remove());
    } catch (_) { }
  },
  lineClamp() {
    return;
    let objClamp = {};
    let arrItems = document.querySelectorAll('[data-wsjs-clamp]');

    arrItems.forEach(elm => {
      let attr = elm.getAttribute('data-wsjs-clamp');
      let clampName = attr.split(':')[0], lineStatic = attr.split(':')[1];


      elm.style.setProperty('-webkit-line-clamp', lineStatic);

      objClamp[clampName] = objClamp[clampName] || {};
      objClamp[clampName].maxLine = objClamp[clampName].maxLine && objClamp[clampName].maxLine >= elm.scrollHeight ? objClamp[clampName].maxLine : elm.scrollHeight;
    });

    function getLineHeight(el) {
      var temp = document.createElement(el.nodeName), ret;
      temp.setAttribute("style", "margin:0; padding:0; "
        + "font-family:" + (el.style.fontFamily || "inherit") + "; "
        + "font-size:" + (el.style.fontSize || "inherit"));
      temp.innerHTML = "A";

      el.parentNode.appendChild(temp);
      ret = temp.clientHeight;
      temp.parentNode.removeChild(temp);

      return ret;
    }

    arrItems.forEach(elm => {
      let attr = elm.getAttribute('data-wsjs-clamp');
      let clampName = attr.split(':')[0], lineStatic = attr.split(':')[1];

      let maxLine = objClamp[clampName].maxLine;


      let lineHeight = getLineHeight(elm);
      let lineToClamp = parseInt(maxLine / lineHeight);


      if (lineToClamp > lineStatic) lineToClamp = lineStatic;

      elm.style.setProperty('max-height', parseInt(lineHeight * lineToClamp) + 'px');
      elm.style.setProperty('min-height', parseInt(lineHeight * lineToClamp) + 'px');
      elm.style.setProperty('-webkit-line-clamp', lineToClamp);
    });
  }
}

// Additional Functions
wsMain.addons = {
  replaceIframe(el) {

    function addFrame() {
      el.innerHTML = `<iframe
      src="https://www.youtube.com/embed/${el.getAttribute('videocode')}" 
      title="YouTube video player" 
      frameborder="0" 
      allow="accelerometer"; 
      autoplay="1"; 
      clipboard-write; 
      encrypted-media; 
      gyroscope; 
      picture-in-picture" 
      allowfullscreen>
    </iframe>`;
      el.removeEventListener('click', addFrame, false)
    }

    el.addEventListener('click', addFrame, false);
  },
  lastScrollPos: scrollY,
  lazyLoad() {
    // Mede TODOS primeiro e só depois altera: medir -> alterar -> medir forçava um reflow por
    // elemento (~300ms de "reflow forçado" no PageSpeed da loja 122). Como carregar um item
    // (tira o min-height) pode puxar os de baixo pra dentro da tela, repete no próximo quadro
    // enquanto algum tiver sido carregado — mesmo resultado do loop antigo.
    const viewportH = window.innerHeight;
    const toLoad = Array.from(document.querySelectorAll("*[data-wsjs-lazyload=scroll]"))
      .filter((elm) => elm.getBoundingClientRect().top - 20 < viewportH);
    if (!toLoad.length) return;
    toLoad.forEach((elm) => wsMain.tools.lazyLoad(elm));
    requestAnimationFrame(() => wsMain.addons.lazyLoad());
  },
  throttle(fn, wait) {
    var time = Date.now();
    return function () {
      if ((time + wait - Date.now()) < 0) {
        fn;
        time = Date.now();
      }
    }
  },
  floatHeader(vrf) {
    let header = document.querySelector('header');
    let headerOptions = wsMain.tools.getWsData(header, 'options');
    let logoHeader = document.querySelector('header .logo-header');
    let maxHeight = logoHeader.getAttribute('data-max-height') || '';
    let minHeight = logoHeader.getAttribute('data-min-height') || '';
    let maxMargin = logoHeader.getAttribute('data-max-margin') || '';
    let minMargin = logoHeader.getAttribute('data-min-margin') || '';
    let bottomQuery = headerOptions.bottomElement;
    let bottomHeader = false;
    if (bottomQuery != false) {
      bottomHeader = document.querySelector(bottomQuery) || document.querySelector('header .header-bottom');
    }
    // Opcionais (data-wsjs-options no <header>) — sem eles, mantém exatamente
    // o comportamento de sempre (limiar proporcional a 35% da altura do
    // header, e 30px de scroll pra cima pra reaparecer). floatThreshold deixa
    // fixar um valor em px (em vez de proporcional à altura do header) pra
    // quando "reduzir só depois de uns Npx de scroll" importa mais que
    // acompanhar a altura; floatRevealDelta deixa o reaparecer mais sensível
    // (ou instantâneo, com 0) que o padrão de 30px.
    let downThreshold = headerOptions.floatThreshold != null
      ? parseInt(headerOptions.floatThreshold, 10)
      : header.offsetHeight * .35;
    let revealDelta = headerOptions.floatRevealDelta != null
      ? parseInt(headerOptions.floatRevealDelta, 10)
      : 30;

    if (scrollY > wsMain.addons.lastScrollPos && scrollY > downThreshold) {
      logoHeader.style.height = minHeight;
      logoHeader.style.margin = minMargin;
      document.querySelector('header').classList.add('float-active')
      if (bottomHeader) {
        bottomHeader.style.pointerEvents = 'none';
        bottomHeader.style.opacity = '0';
        bottomHeader.style.transform = 'translateY(-101%)';
      }
    }



    if (
      vrf
      ||
      scrollY < downThreshold
      ||
      (
        // Antes comparava contra 4% da altura da PÁGINA INTEIRA (scrollHeight) — numa
        // página longa (listagem/produto), isso exigia 100-300px+ de scroll pra cima NUM
        // SÓ evento pra reaparecer, o que touch/trackpad quase nunca disparam de uma vez
        // (eventos de scroll chegam picotados em deltas pequenos) — na prática o menu
        // sumia ao rolar pra baixo e não voltava mais até chegar no topo da página. Valor
        // fixo pequeno (revealDelta, 30 por padrão): qualquer scroll pra cima perceptível
        // já traz o menu de volta.
        Math.abs(scrollY - wsMain.addons.lastScrollPos) > revealDelta
        &&
        scrollY < wsMain.addons.lastScrollPos
      )
    ) {
      logoHeader.style.height = maxHeight;
      logoHeader.style.margin = maxMargin;
      document.querySelector('header').classList.remove('float-active')
      if (bottomHeader) {
        bottomHeader.style.pointerEvents = 'all';
        bottomHeader.style.opacity = '';
        bottomHeader.style.transform = 'translateY(0)';
      }
    }

    this.lastScrollPos = scrollY;
  },
  headerFirstLoad() {
    let header = document.querySelector('header');
    let headerOptions = wsMain.tools.getWsData(header, 'options');
    if (headerOptions.float != true) return;

    setTimeout(() => document.querySelector('header .logo-header').style.transition = 'all 300ms ease 0s, font-size 0s ease 0s', 10);
    if (typeof nPanel != 'undefined' && nPanel.token) return;

    function onResize() {
      if (!header.classList.contains('float-active')) {
        header.parentNode.style.paddingTop = header.offsetHeight + 'px';
      }
    }

    header.style.zIndex = '3';
    header.style.position = 'fixed';
    // onResize() precisa rodar JUNTO com o position:fixed acima, não 5ms depois — virar fixed
    // tira o header do fluxo instantaneamente (todo o conteúdo abaixo sobe pra preencher o
    // espaço), e só o padding-top compensatório (que reserva esse espaço de volta) devolve a
    // posição certa. Com um intervalo entre as duas mudanças, o navegador pinta o estado
    // intermediário (conteúdo colado no topo) antes de corrigir — duas trocas de layout reais
    // (evidenciadas no rastro de CLS) por algo que devia ser uma coisa só, sem intervalo visível.
    onResize();

    // headerFirstLoad() roda cedo (chamado pelo init dos módulos de categoria, antes de
    // qualquer imagem terminar de carregar) — se o logo ainda não carregou nesse momento,
    // header.offsetHeight acima já pode não bater com a altura final do header (ex.: o logo
    // troca de proporção/quebra de linha só depois de ter as dimensões reais). Sem isso, o
    // padding-top compensatório fica desatualizado até o próximo dos "corretivos" abaixo (o
    // setInterval de 1s, ou o listener de resize) rodar — nesse meio-tempo o header (fixed)
    // fica mais alto que o espaço reservado e cobre/"come" o topo do conteúdo seguinte (efeito
    // relatado: página parece já carregar com scroll pra baixo, corrige sozinho ao rolar,
    // porque a essa altura algum dos corretivos já rodou). Recalculando na hora certa: assim
    // que a imagem do logo terminar de carregar (ou de imediato, se já estava em cache).
    let logoImg = document.querySelector('header .logo-header img');
    if (logoImg && !logoImg.complete) {
      logoImg.addEventListener('load', onResize, { once: true });
    }

    if (headerOptions.scroll == false) return;
    let booleanScroll = true;

    function onScroll() {
      if (scrollY < header.offsetHeight * .35) wsMain.addons.floatHeader(true);
      if (booleanScroll) {
        booleanScroll = false;
        setTimeout(() => {
          wsMain.addons.floatHeader();
          booleanScroll = true;
        }, 500);
      };
    }

    setInterval(onResize, 1000);
    document.addEventListener('resize', onResize);
    // Era "document.addEventListener('load', onResize)" — o evento "load" da window não
    // borbulha (bubble) até o document, então esse listener nunca disparava de fato; sobrava só
    // o setInterval de 1s (e agora o listener no <img> do logo acima) como corretivo real.
    window.addEventListener('load', onResize);
    document.addEventListener('scroll', onScroll);

    onScroll();
  },
  dataLoad(elm) {
    while (elm) {
      try {
        if (elm.getAttribute('data-wsjs-container') != null) elm.removeAttribute('data-wsjs-container');
        if (document.querySelector('#HdEtapaLoja').value == 'HOME' && elm.getAttribute('data-wsjs-clsid')) elm.removeAttribute('data-wsjs-clsid');
        if (document.querySelector('#HdEtapaLoja').value == 'HOME' && elm.getAttribute('data-wsjs-sectype')) elm.style.minHeight = '';
      } catch (e) { }
      elm = elm.parentNode;
    }
  },
  // Escolhe um título descritivo pro iframe a partir do host/caminho do src — cobre os
  // widgets de terceiro mais comuns (selo de avaliações do Google, YouTube, Mercado Pago)
  // com um nome específico; qualquer outro cai num nome genérico a partir do host, que
  // ainda é muito melhor que nenhum título pra quem usa leitor de tela (WCAG 4.1.2 / regra
  // "frame-title" do axe/Lighthouse). Nunca inventa conteúdo que não dá pra confirmar.
  pickIframeTitle(iframe) {
    const src = iframe.getAttribute('src') || '';
    let host = '';
    try { host = new URL(src, location.href).hostname; } catch (e) { }

    if (/(^|\.)google\.com$/.test(host) && /merchantverse|customerreviews|ratingbadge/i.test(src)) {
      return 'Selo de avaliações verificadas do Google';
    }
    if (/(^|\.)google\.com$/.test(host) && /\/maps\//.test(src)) {
      return 'Mapa do Google';
    }
    if (/(^|\.)youtube(-nocookie)?\.com$/.test(host)) {
      return 'Vídeo do YouTube';
    }
    if (/(^|\.)mercadopago\.com/.test(host)) {
      return 'Formulário de pagamento Mercado Pago';
    }
    if (host) return `Conteúdo incorporado de ${host}`;

    // Sem host identificável (about:blank, srcdoc, ainda sem src) — nome genérico só pra
    // não deixar o frame mudo pro leitor de tela.
    return 'Conteúdo incorporado';
  },
  // MutationObserver leve — só reage a nós adicionados (nunca varre a árvore inteira a
  // cada mutação) — que dá título a qualquer <iframe> de terceiro sem title/aria-label/
  // aria-labelledby, incluindo os que scripts de terceiro (selo do Google, chat, etc.)
  // injetam bem depois do load. Rodamos aqui (wsapi3-main, global) porque o problema é
  // genérico — qualquer app/script de terceiro pode injetar um iframe sem título, em
  // qualquer loja, a qualquer momento; não é algo pra reimplementar módulo por módulo.
  ensureIframeTitles() {
    function label(iframe) {
      if (!iframe || iframe.tagName !== 'IFRAME') return;
      if (iframe.hasAttribute('title') || iframe.hasAttribute('aria-label') || iframe.hasAttribute('aria-labelledby')) return;
      try { iframe.setAttribute('title', wsMain.addons.pickIframeTitle(iframe)); } catch (e) { }
    }

    document.querySelectorAll('iframe').forEach(label);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          if (node.tagName === 'IFRAME') label(node);
          else if (node.querySelectorAll) node.querySelectorAll('iframe').forEach(label);
        });
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
}

wsMain.help = async () => {
  if (!wsMain.helpModObj) {
    let response = await fetch('https://cdns3.webstore.net.br/files/0ws/dragdrop/wsHelp.json')
    let data = await response.json();
    wsMain.helpModObj = data;
  }

  return wsMain.helpModObj;
}

wsMain.version = {
  number: document.querySelector('[data-wsjs-draginner]')?.getAttribute('data-wsjs-draginner') || '0.0.1',
  compare(a, b = wsMain.version.number) {
    if (a === b) {
      return 0;
    }

    var a_components = a.split(".");
    var b_components = b.split(".");

    var len = Math.min(a_components.length, b_components.length);

    // loop while the components are equal
    for (var i = 0; i < len; i++) {
      // A bigger than B
      if (parseInt(a_components[i]) > parseInt(b_components[i])) {
        return 1;
      }

      // B bigger than A
      if (parseInt(a_components[i]) < parseInt(b_components[i])) {
        return -1;
      }
    }

    // If one's a prefix of the other, the longer one is greater.
    if (a_components.length > b_components.length) {
      return 1;
    }

    if (a_components.length < b_components.length) {
      return -1;
    }

    // Otherwise they are the same.
    return 0;
  }

}

if (document.querySelector('#HdEtapaLoja').value == 'HOME' && typeof placeholderHome != 'undefined') {
  wsMain.placeHolders = {
    banners: {
      full: {
        height: '300px'
      },
      topo: {
        height: '300px'
      },
      tarja: {
        height: '90px'
      },
      mini: {
        height: '150px'
      },
      rodape: {
        height: '300px'
      }
    },
    condicoes: {
      qtd: placeholderHome?.condicoes || 0,
      height: '12rem'
    },
    fabricantes: {
      qtd: placeholderHome?.fabricantes || 0,
      height: '17rem'
    },
    grupos: {
      qtd: placeholderHome?.grupos || 0,
      height: '51rem'
    },
    produtos: {
      qtd: placeholderHome?.produtos || 0,
      height: '51rem'
    }
  };
}

// version/updatedAt são campos opcionais que cada módulo declara no seu próprio createModule({...});
// servem só para debug (ver window.wsAppInfo no console) e não afetam a execução.
wsMain.getModulesInfo = function () {
  return Object.values(wsMain.modules).map((mod) => ({
    name: mod.name,
    version: mod.version || null,
    updatedAt: mod.updatedAt || null,
  }));
};

wsMain.showAlert = function (msg, title) {
  var overlay = document.getElementById('ws-main-alert-overlay');

  if (!overlay) {
    overlay = document.createElement('div');
    overlay.id = 'ws-main-alert-overlay';
    overlay.className = 'ws-main-alert-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'ws-main-alert-title');
    overlay.innerHTML =
      '<div class="ws-main-alert-box">' +
        '<button class="ws-main-alert-close" aria-label="Fechar">&times;</button>' +
        '<h3 class="ws-main-alert-title" id="ws-main-alert-title">Atenção</h3>' +
        '<p class="ws-main-alert-msg" id="ws-main-alert-msg"></p>' +
        '<button class="ws-main-alert-btn button-third" id="ws-main-alert-ok">OK</button>' +
      '</div>';
    document.body.appendChild(overlay);
  }

  var titleEl = overlay.querySelector('#ws-main-alert-title');
  var msgEl   = overlay.querySelector('#ws-main-alert-msg');
  if (titleEl) titleEl.textContent = title || 'Atenção';
  // textContent (não innerHTML): a mensagem costuma vir de result.message da
  // API / validações — tratar sempre como texto puro.
  if (msgEl)   msgEl.textContent   = msg == null ? '' : String(msg);

  overlay.style.display = 'flex';

  function close() { overlay.style.display = 'none'; }

  var okBtn    = overlay.querySelector('#ws-main-alert-ok');
  var closeBtn = overlay.querySelector('.ws-main-alert-close');
  if (okBtn)    okBtn.onclick    = close;
  if (closeBtn) closeBtn.onclick = close;
  overlay.onclick = function (e) { if (e.target === overlay) close(); };
};

/* ─────────────────────────────────────────────────────────────
   alert() nativo é banido da storefront — é feio e quebra a
   identidade visual da loja. A partir daqui todo window.alert()
   (módulos padrão, bridge wsapi3-adaptions-api2-to-api3, módulos
   de loja e apps de terceiros) renderiza o modal padrão
   wsMain.showAlert. confirm()/prompt() NÃO são tocados — dependem
   do retorno síncrono. O alert nativo segue acessível em
   wsMain.nativeAlert se algum fluxo realmente precisar.
   ───────────────────────────────────────────────────────────── */
try {
  wsMain.nativeAlert = window.alert.bind(window);
  window.alert = function (msg) {
    try { wsMain.showAlert(msg == null ? '' : String(msg), 'Atenção'); }
    catch (e) { wsMain.nativeAlert(msg); }
  };
} catch (e) {}

// Running all modules
window.addEventListener("load", async () => {
  try {
    let newsTitle = document.querySelector('.newsletter-text h2');
    if (newsTitle.innerHTML.trim() == '') newsTitle.parentNode.remove();
  } catch (_) { }

  try {
    let etapa = (document.querySelector('#HdEtapaLoja') || {}).value || '';
    let regId = window.__WS_SERVER_DATA__?.page?.resourceId
      || document.querySelector('#LV_HD_PROD_ID')?.value
      || document.querySelector('#HD_CAT_ID')?.value
      || 0;
    ApiWS.Navigation.track(etapa, window.location.pathname, regId);
  } catch (_) { }

  // Semeia o e-mail conhecido a partir do cliente logado (injetado no DOM em
  // toda página) — cobre quem já estava logado antes desta feature existir.
  try {
    let cliEmail = (document.querySelector('#HD_LVCLI_EMAIL') || {}).value || '';
    if (cliEmail && ApiWS.CustomerEmail) {
      ApiWS.CustomerEmail.set(cliEmail, { source: 'session', authoritative: true });
    }
  } catch (_) { }

  await wsMain.exec(false, 'Level 0');

  try { if (typeof searchAdvanced == 'undefined') { BuscaInicializa('input-busca'); } } catch (e) { }
  console.warn('All modules executed')

  try {
    window.wsAppInfo = Object.assign({}, window.wsAppInfo, { modules: wsMain.getModulesInfo() });
    console.info('%cWS App Info', 'font-weight:bold', window.wsAppInfo);
  } catch (e) { }

  if (typeof nPanel == 'undefined') {
    document.querySelectorAll('.pseudo-youtube-frame').forEach(el => wsMain.addons.replaceIframe(el))
  }
});

// Declaring LazyLoad Function
document.addEventListener("scroll", wsMain.addons.lazyLoad);

// Título automático em <iframe> de terceiro sem title/aria-label (selo de avaliações do
// Google, chat, etc.) — ver wsMain.addons.ensureIframeTitles. Chamado aqui, direto (sem
// esperar DOMContentLoaded/load): o MutationObserver já fica de pé assim que o script
// roda, e document.documentElement sempre existe nesse ponto do parsing.
try { wsMain.addons.ensureIframeTitles(); } catch (e) { }

// Fallback nativo de "Enter busca" — chamado logo acima (ver window.addEventListener('load', ...))
// só quando a loja NÃO tem o app AdvancedSearch instalado (esse app define `var searchAdvanced = true`
// global antes de registrar seu próprio módulo; sem ele, `searchAdvanced` fica undefined). Cobre
// QUALQUER input cujo id contenha idContains (cada tema nomeia o campo de busca à sua maneira —
// "input-busca", "input-busca-mobile", etc. — por isso o match é *= e não id exato).
function BuscaInicializa(idContains) {
  document.querySelectorAll('input[id*="' + idContains + '"]').forEach((input) => {
    if (input.dataset.wsBuscaBound) return;
    input.dataset.wsBuscaBound = '1';

    input.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter') return;
      e.preventDefault();

      const termo = normalizarTermoBusca(input.value || '');
      if (!termo) return;

      window.location.href = '/busca?s=' + encodeURIComponent(termo);
    });
  });
}

// Remove acentos e caracteres especiais, e troca espaços por "-" (ex.: "Jaqueta Jeans!!" -> "jaqueta-jeans").
function normalizarTermoBusca(termo) {
  return termo
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
}

function isReady(mod, funcToCall) {
  if (mod == 'allModulosOk') {
    let modVerify = setInterval(() => {
      let allOk = true;
      wsMain.moduleArr.forEach((mods) => {
        if (mods.isOk == false) allOk = false;
      });

      if (allOk) {
        clearInterval(modVerify);
        try { funcToCall() } catch (_) { }
      }
    }, 100);

  } else {
    let modVerify = setInterval(() => {
      wsMain.moduleArr.forEach((mods) => {
        if (mods.funcName == mod && mods.isOk == true) {
          clearInterval(modVerify);
          try { funcToCall() } catch (_) { }
        }
      });
    }, 100);
  }
}
